import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ShopCart from '~/backend/shop_cart';
import { formatAmountValue } from '~/common/helper';
import Button from '~/components/common/Button';
import Modal from '~/components/common/Modal';

const AppliedDiscountsModal = ({ appliedDiscounts, open, setOpen }) => {
	const { t } = useTranslation();

	const products = ShopCart.getItems();

	return (
		<div className="discounts-poupup-modal">
			<Modal open={open} setOpen={setOpen} className="discounts-popup">
				<div className="discounts-popup-container">
					<div className="header">
						<div className="title">{t('discounts_applied')}</div>
					</div>
					<div className="body">
						{/* <h4>Συμπλήρωσε το email σου για να κερδίσεις:</h4> */}
						<ul className="discounts-features">
							{appliedDiscounts?.map(({ dt, cd, ln, oamn, odamt, amn, descr, has_capped }, index) => (
								<li key={index}>
									<div className="row-header">
										<h5>
											{t(dt)} {cd ? <b>{cd}</b> : <b>{products[ln - 1]?.product?.nm}</b>}
											{descr ? <b> {descr}</b> : null}
										</h5>
										{amn > 0 && (
											<div className="row-header-amounts">
												{odamt > 0 && odamt > amn && <span className="amount-original">{formatAmountValue(odamt)}</span>}
												<span>{formatAmountValue(amn)}</span>
											</div>
										)}
									</div>
									{oamn > 0 && (
										<div className="row-oamt">
											<small>Διαθέσιμο Ποσό: {formatAmountValue(oamn)}</small>
										</div>
									)}
									{has_capped && (
										<div className="row-capped">
											<small>{t('applied_discounts_cap_notice')}</small>
										</div>
									)}
								</li>
							))}
						</ul>
					</div>

					<div className="footer">
						<Button color="secondary" actionOnClick={() => setOpen(false)}>
							{t('close')}
						</Button>
					</div>
				</div>
			</Modal>
		</div>
	);
};

AppliedDiscountsModal.propTypes = {
	appliedDiscounts: PropTypes.array,
	open: PropTypes.bool,
	setOpen: PropTypes.func
};

export default AppliedDiscountsModal;
